import {useContractStatus} from 'presentation/hooks';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants/bookingTypeEnum';
import {useAccountInformation} from 'presentation/pages/private/hooks/useAccountInformation';
import {BookingServiceTypeValidation} from './types';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {ContractTypeEnum} from 'presentation/constants';
import {useCongenereEligibilityStore} from 'presentation/pages/private/store/useCongenereEligibilityStore';

export function useValidateBookingServiceType(): BookingServiceTypeValidation {
	const {
		flPlanoSomenteHospitalar,
		healthOnly,
		healthOdonto,
		isResponsibleWithoutBenefits,
		isEarlyAccess,
	} = useAccountInformation();
	const {sidebar, beneficiary} = useAccountDataStore(state => state.accountData);
	const {isValid, isContractSuspended} = useContractStatus();
	const {congenereEligibility} = useCongenereEligibilityStore();

	const BUSINESS_PLAN = beneficiary.tipoContratacao === ContractTypeEnum.EMPRESARIAL;
	const FINANCIAL_PENDENCY_PLAN = BUSINESS_PLAN && sidebar.flUsuarioInadimplente;

	const showBookService =
		!isResponsibleWithoutBenefits &&
		(healthOdonto || (healthOnly && !flPlanoSomenteHospitalar)) &&
		!FINANCIAL_PENDENCY_PLAN;

	const showHealthBookServiceForShortcut = !isContractSuspended && showBookService;

	const showBookTelehealth =
		isValid && !isContractSuspended && showBookService && !isEarlyAccess && !congenereEligibility;
	const showBookHealth =
		isValid && showHealthBookServiceForShortcut && !isEarlyAccess && !congenereEligibility;
	const showBookExams =
		isValid && !isContractSuspended && showBookService && !isEarlyAccess && !congenereEligibility;

	const flagsByServiceType: Partial<Record<BookingTypeEnum, boolean>> = {
		[BookingTypeEnum.TELEHEALTH]: showBookTelehealth,
		[BookingTypeEnum.HEALTH]: showBookHealth,
		[BookingTypeEnum.EXAM]: showBookExams,
	};

	const isServiceTypeValid = (serviceType: string | null): boolean => {
		if (!serviceType) return false;
		return flagsByServiceType[serviceType as BookingTypeEnum] ?? false;
	};

	const hasAnyBookingAvailable = showBookTelehealth || showBookHealth || showBookExams;

	return {
		isServiceTypeValid,
		hasAnyBookingAvailable,
	};
}
